/**
 * Fetches data from the api and sets it in session storage
 * @param {string} storageValueName - the name of the session storage value
 * @param {function} fetcher -async function that returns the data to be set in session storage
 * @param {function} replacer - optional replacer function for JSON.stringify
 * @param {function} reviver - optional reviver function for JSON.parse
 */
export default async (storageValueName, fetcher, replacer, reviver) => {
  const count = Number(sessionStorage.getItem(`${storageValueName}ActionCallCount`)) ?? 0;
  const myId = count + 1;
  sessionStorage.setItem(`${storageValueName}ActionCallCount`, myId);
  let content;

  // this prevents parallel calls to the api when uxp categories is not saved
  // it will wait up to 2s for the first call to finish and set the session storage
  if (myId > 1 && !sessionStorage.getItem(storageValueName)) {
    await new Promise((resolve) => {
      const intervalID = setInterval(() => {
        if (sessionStorage.getItem(storageValueName)) {
          clearTimeout(timeoutID);
          clearInterval(intervalID);
          resolve();
        }
      }, 50);
      const timeoutID = setTimeout(() => {
        clearInterval(intervalID);
        clearTimeout(timeoutID);
        resolve();
      }, 2000);
    });
  }
  if (!sessionStorage.getItem(storageValueName)) {
    content = await fetcher();
    sessionStorage.setItem(storageValueName, JSON.stringify(content, replacer));
  } else {
    content = JSON.parse(sessionStorage.getItem(storageValueName), reviver);
  }

  return content;
};
